import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FiltersService {

    private url = environment.urlApi;
    // private propiedades: any[];
    constructor(private http: HttpClient) {


    }

    getUrlApi( query: string){

         const url = `${this.url}/${query}`;

         return this.http.get(url);
    }

    getLocalidad(){
        return this.getUrlApi( `Localidades`)
       .pipe(
           map((resp: any[]) =>
           resp.map(Localidades => ( {id: Localidades.id, code: Localidades.code, descripcion: Localidades.descripcion})
           )
           )
       );
    }

    getBarrio(){
        return this.getUrlApi( `Barrios`)
        .pipe(
            map((resp: any[]) =>
            resp.map(Barrios => ( {id: Barrios.id,code: Barrios.code, descripcion: Barrios.descripcion, localidadId: Barrios.localidadId, codeLocalidad: Barrios.codeLocalidad})
            )
            )
        );
     }
     getTipoPro(){
        return this.getUrlApi( `TiposPropiedad`)
        .pipe(
            map((resp: any[]) =>
            resp.map(TiposPropiedad => ( {id: TiposPropiedad.id,code: TiposPropiedad.code, descripcion: TiposPropiedad.descripcion})
            )
            )
        );
     }
     getTipoOpe(){
        return this.getUrlApi( `TiposOperacion`)
        .pipe(
            map((resp: any[]) =>
            resp.map(TiposOperacion => ( {id: TiposOperacion.id,code: TiposOperacion.code, descripcion: TiposOperacion.descripcion})
            )
            )
        );
     }
     getCaracteristicasProp(){
        return this.getUrlApi( `CaracteristicasPropiedad`)
        .pipe(
            map((resp: any[]) =>
            resp.map(CaractersiticasPropiedad => ( {id: CaractersiticasPropiedad.id, code: CaractersiticasPropiedad.code, descripcion: CaractersiticasPropiedad.descripcion})
            )
            )
        );
     }
     getTipoMoneda(){
        return this.getUrlApi( `TiposMoneda`)
        .pipe(
            map((resp: any[]) =>
            resp.map(TipoMoneda => ( {id: TipoMoneda.id, code: TipoMoneda.code, descripcion: TipoMoneda.descripcion})
            )
            )
        );
     }
}

